import { } from '../extendroute.manager';
import { autobind } from 'frontools/decorators/Autobind';
import { debounce } from 'frontools/decorators/Debounce';

import Breakpoint from 'frontools/core/Breakpoint';
import Context from 'frontools/core/Context';

import LazyLoadManager, { LazyLoadManagerOptions } from 'frontools/medias/image/LazyLoadManager';   
import AnimManager, { AnimManagerOptions, AnimManagerEvent } from 'frontools/animations/AnimManager';

import { timeout } from 'frontools/decorators/Timeout';
import ScrollUtils from 'frontools/utils/ScrollUtils';
import VanillaUtils from 'frontools/utils/VanillaUtils';

import { MobileNav } from '../modules/MobileNav';
import { Quotes } from '../modules/Quotes';
import { Tile } from '../modules/Tile';
import Utils from '../modules/Utils';
import ExtendRouteManager from '../extendroute.manager';
import { Overlay, OverlayOptions } from '../modules/Overlay';

declare var Masonry;

export default class AbstractPage {

    protected _lastBreakpoint           : string;

    private _supportPositionSticky      : boolean;

    private _overlay                    : Overlay;
    private _overlayOptions             : OverlayOptions                = new OverlayOptions();

    protected _mobileNav                : MobileNav     = undefined;
    protected _quotes                   : Quotes;
    protected _animManager              : AnimManager;
    protected _lazyLoadManager          : LazyLoadManager;
    protected _masonryGrid              : any;

    protected _tiles                    : Array<Tile>                   = [];

    protected _isNavActive              : boolean       = true;
    protected _isCatfishActive          : boolean       = false;
    protected _isMobile                 : boolean       = false;

    protected _lastScrollTop            : number        = document.body.scrollTop;
    protected _navTop                   : number;

    protected _elNav                    : HTMLElement;
    protected _elHeader                 : HTMLElement;
    protected _elFilterNav              : HTMLElement;
    protected _elFooterCatfish          : HTMLElement;
    protected _elGrid                   : HTMLElement;

    constructor() {
        // this._onResize();
        // window.addEventListener('resize', this._onResize);

        var quotes = document.querySelector('[data-quotes]') as HTMLElement;
        if (quotes) this._quotes = new Quotes(quotes);      

        // this._supportPositionSticky = function() {var el=document.createElement('a'),mStyle=el.style;mStyle.cssText="position:sticky;position:-webkit-sticky;position:-ms-sticky;";return mStyle.position.indexOf('sticky')!==-1;}();
        
        this._elNav = document.querySelector('[data-main-nav]') as HTMLElement;
        this._elHeader = document.querySelector('.header_main') as HTMLElement;
        this._bindHeaderLinksClick();
        
        let lazyLoadOptions = new LazyLoadManagerOptions();
        // lazyLoadOptions.offset = -1000;
        lazyLoadOptions.offset = 0;
        this._lazyLoadManager = new LazyLoadManager(lazyLoadOptions);        
        
        this._createMasonry();        
        this._createGrid(); 
        this._initAnimManager();
        
        this._registerNavScroll();


        setTimeout(()=> {
            Utils.objectFitPolyfill();  
            Breakpoint.trigger();
        }, 500);

        // this.onResize();
        window.addEventListener('resize', this.onResize.bind(this));

        Breakpoint.on('group_large', this.onResizeDesktop.bind(this));
        Breakpoint.on('group_small', this.onResizeMobile.bind(this));

    }

    protected onResizeMobile() {
        // this._isMobile = true;
        if (this._quotes) this._quotes.fixMainMargin(false);
        if (this._lastBreakpoint == Breakpoint.MOBILE) return;
        if (!this._mobileNav) this._mobileNav = new MobileNav();

        // this._mobileNav.addListener(Overlay.OPEN, ()=>{ 
        //     console.log('open', ExtendRouteManager.instance);
        //     setTimeout(() => {
        //         ExtendRouteManager.instance.parseLinks();
        //     }, 1000)
        // })

        this._registerMobileScroll();
        this._lastBreakpoint = Breakpoint.MOBILE;
        // if (this._masonryGrid) {
        //     this._masonryGrid.destroy();
        //     this._masonryGrid = undefined;
        //     this._destroyTiles();       
        // }
    }

    protected onResizeDesktop() {
        // this._isMobile = false;
        if (this._quotes) this._quotes.fixMainMargin(false);
        if (this._lastBreakpoint == Breakpoint.DESKTOP) return; 
        if (this._mobileNav) this._mobileNav.destroy();
        if (this._elFilterNav) this._elFilterNav.classList.remove('fixed'); 
        this._elNav.classList.remove('static');
        this._registerDesktopScroll();
        this._lastBreakpoint = Breakpoint.DESKTOP;
        this._initAnimManager();
         
     }

     private _initAnimManager() {
        if (!this._animManager) {
            this._animManager = new AnimManager();  
            this._animManager.addCustomAnimation('fromBottomLong', (e: AnimManagerEvent) => {
                TweenMax.from(e.target, 3, {delay: 0.5 + (e.animationQueueIndex * .1), y: 150, alpha: 0, ease: Expo.easeOut, 
                    onComplete: () => {
                        TweenMax.set(e.target, {clearProps: 'all'})
                    }
                });
            })
        } 
     }

    @debounce(100)
    protected onResize() {
        // Overridable 
    }  

    private _registerMobileScroll() {
        this._elFilterNav = document.querySelector('[data-filter-nav]') as HTMLElement;
        if (this._elFilterNav) {
            var filterTop = VanillaUtils.getOffsetRect(this._elFilterNav).top;
            ScrollUtils.registerElement(filterTop, {
                offset: this._elFilterNav.offsetHeight,
                before: function() { 
                    if (this._elFilterNav.classList.contains('fixed') && Breakpoint.isLowerThan(Breakpoint.TABLET)) {
                        this._elNav.classList.remove('static'); 
                        this._elFilterNav.classList.remove('fixed'); 
                    }
                }.bind(this),
                after: function() { 
                    if (!Breakpoint.isLowerThan(Breakpoint.TABLET)) return;
                    this._elNav.classList.add('static');
                    this._elFilterNav.classList.add('fixed'); 
                }.bind(this)
            })
        }
        ScrollUtils.removeRegistredElement(window);        
        ScrollUtils.triggerEventOf(window);
    }  
        
    private _registerDesktopScroll() {
        this._elFooterCatfish = document.querySelector('footer .contact_catfish') as HTMLElement;
        if (this._elFooterCatfish) TweenMax.set(this._elFooterCatfish, {y:"100%"});
        ScrollUtils.registerEventTo(window, this._onScroll, true);  
        ScrollUtils.triggerEventOf(window); 
    }

    private _registerNavScroll() {
        // This is only used to set padding to sticky nav
        if (!this._elNav) return;

        let hero = document.querySelector('.hero_main') as HTMLElement;

        let el = this._elNav;
        if (hero) {
            el = document.querySelector('main') as HTMLElement;
        }

        ScrollUtils.registerElement(el, {
            offset: -this._elNav.offsetHeight*2,
            before: function() {
                this._elNav.classList.remove('sticky'); 
            }.bind(this),
            after: function() { 
                this._elNav.classList.add('sticky');    
            }.bind(this)
        })
    }

    protected _createGrid() {
        if (document.documentElement.classList.contains('no-touchevents')) {
            this._createTiles();            
        }
    }

    protected _createMasonry() {
        this._elGrid = document.querySelector('[data-grid]') as HTMLElement;
        if (this._elGrid) {
            this._masonryGrid = new Masonry(  this._elGrid, {   
                itemSelector: '.g_item',
            });  
        }
        // this._createGrid(); 
    }

    private _createTiles() {
        var tiles = document.querySelectorAll('[data-tile]') as NodeListOf<HTMLElement>;
        if (tiles) {
            for (var index = 0; index < tiles.length; index++) {
                this._tiles.push(new Tile(tiles[index] as HTMLElement));
            }
        }
    }

    private _bindHeaderLinksClick() {
        let overlayLink = document.querySelector('[data-header-filter-button]');
        let list = document.querySelector('[data-header-filter-lists]') as HTMLElement;

        console.log(overlayLink, list, this._elHeader);
        if (list && overlayLink) {
            let listClone = list.cloneNode(true) as HTMLElement;
            let overlayEls = listClone.querySelectorAll('h2, a') as NodeListOf<HTMLElement>;
            
            TweenMax.set(overlayEls, {opacity:0, y: -50, display:'block'});
            
            overlayLink.addEventListener('click', (e) => {
                e.preventDefault();
                this._overlayOptions.customClasses = "menu_nav";
                this._overlayOptions.wrapperCustomClasses = "menu header_overlay";
                this._overlay = new Overlay(listClone, this._overlayOptions);
                this._overlay.addListener(Overlay.OPEN, function() {
                    TweenMax.staggerTo(overlayEls, 0.05, {opacity: 1, y:0, ease: Expo.easeOut}, 0.01);          
                }.bind(this))
            });
        }
    }

    protected _destroyTiles() {
        for (var index = 0; index < this._tiles.length; index++) {
            this._tiles[index].destroy();
        }
    }

    @autobind
    protected _onScroll(e) {
        var st = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
        if (st > this._lastScrollTop) this._onScrollDown();
        else this._onScrollUp();
        if (st <= 90) this._onScrollUp(true); //Forcing scroll up showing nav when arriving from further in page
        this._lastScrollTop = st;
    }

    protected _onScrollDown() { 
        let hero = document.querySelector('.hero_main') as HTMLElement;
        let offset = (hero && hero.offsetHeight != 0) ? window.innerHeight : 150;
        let st = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
        if (this._isNavActive && st > offset) {
            if (this._elFooterCatfish) TweenMax.to(this._elFooterCatfish, 0.4, {y:"0%"});
            this._isNavActive = false;  
        }   
    }

    protected _onScrollUp(force?: boolean) {
        if ((!this._isNavActive) || force) {
            if (this._elFooterCatfish) TweenMax.to(this._elFooterCatfish, 0.4, {y:"100%"});
            this._isNavActive = true;
        }
    }

}